import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { useAuth } from '../hooks/useAuth';

const navigation = [
  { name: 'Home', href: '/', current: false },
  { name: 'Pizze', href: '/pizze', current: false },
  { name: 'Pizzerie', href: '/pizzerie', current: false },
];

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export default function Navbar() {
  const { user, signOut } = useAuth();
  const location = useLocation();

  const isCurrentPath = (path: string) => location.pathname === path;

  return (
    <Disclosure as="nav" className="bg-pizzaveg shadow-lg" style={{ fontFamily: 'var(--menu-font)' }}>
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="relative flex h-20 items-center justify-between">
              <div className="flex flex-1 items-center justify-start">
                <div className="flex flex-shrink-0 items-center">
                  <Link to="/" className="transform hover:scale-105 transition-transform duration-200">
                    <img
                      className="h-12 w-auto"
                      src="https://pizzaveg.it/materiale/logo-pizzaveg-orizz-1000.png"
                      alt="PizzaVeg"
                    />
                  </Link>
                </div>
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={classNames(
                          isCurrentPath(item.href)
                            ? 'bg-pizzaveg-dark text-white'
                            : 'text-white hover:bg-pizzaveg-light hover:scale-105',
                          'rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200'
                        )}
                      >
                        {item.name}
                      </Link>
                    ))}
                    <Link
                      to="/il-progetto"
                      className={classNames(
                        isCurrentPath('/il-progetto')
                          ? 'bg-pizzaveg-dark text-white'
                          : 'text-white hover:bg-pizzaveg-light hover:scale-105',
                        'rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200'
                      )}
                    >
                      Il Progetto
                    </Link>
                    {user?.role === 'admin' && (
                      <Link
                        to="/admin"
                        className={classNames(
                          isCurrentPath('/admin')
                            ? 'bg-pizzaveg-dark text-white'
                            : 'text-white hover:bg-pizzaveg-light hover:scale-105',
                          'rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200'
                        )}
                      >
                        Amministrazione
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {user ? (
                  <Menu as="div" className="relative ml-3">
                    <Menu.Button className="text-white hover:bg-pizzaveg-light rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 hover:scale-105">
                      {user?.role === 'pizzeria' ? 'Gestione' : 'Account'}
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-150"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-lg bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/profile"
                              className={classNames(
                                active ? 'bg-gray-50' : '',
                                'block px-4 py-2 text-sm text-gray-700 hover:text-pizzaveg transition-colors'
                              )}
                            >
                              Il tuo profilo
                            </Link>
                          )}
                        </Menu.Item>
                        {user?.role === 'pizzeria' && (
                          <Menu.Item>
                            {({ active }) => (
                              <Link
                                to="/profile?tab=1"
                                className={classNames(
                                  active ? 'bg-gray-50' : '',
                                  'block px-4 py-2 text-sm text-gray-700 hover:text-pizzaveg transition-colors'
                                )}
                              >
                                Gestione pizzerie
                              </Link>
                            )}
                          </Menu.Item>
                        )}
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              onClick={signOut}
                              className={classNames(
                                active ? 'bg-gray-50' : '',
                                'block w-full text-left px-4 py-2 text-sm text-gray-700 hover:text-pizzaveg transition-colors'
                              )}
                            >
                              Esci
                            </button>
                          )}
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                ) : (
                  <div className="space-x-2">
                    <Link
                      to="/register"
                      className="text-white bg-pizzaveg-dark hover:bg-pizzaveg-light rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 hover:scale-105"
                    >
                      Registrati
                    </Link>
                    <Link
                      to="/login"
                      className="text-white hover:bg-pizzaveg-light rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 hover:scale-105"
                    >
                      Accedi
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
}